import { Card, Timeline } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ReturnRoot } from '@repo/sdk'
import { formatKstDateTime } from '../../utils/formatKstDateTime'

interface ReturnTimelineCardProps {
  returnData: ReturnRoot
}

function formatTimestamp(timestamp: string): string {
  return formatKstDateTime(timestamp, 'YYYY-MM-DD HH:mm:ss')
}

export function ReturnTimelineCard({ returnData }: ReturnTimelineCardProps) {
  const { t } = useTranslation()

  const items = [
    {
      color: 'blue',
      children: `${t('pages.returns.fields.requestDateTime')}: ${formatTimestamp(returnData.requestedAt)}`,
    },
  ]

  if (returnData.approvedAt) {
    items.push({
      color: 'green',
      children: `${t('common.status.returnApproved')}: ${formatTimestamp(returnData.approvedAt)}`,
    })
  }

  if (returnData.rejectedAt) {
    items.push({
      color: 'red',
      children: `${t('common.status.returnRejected')}: ${formatTimestamp(returnData.rejectedAt)}`,
    })
  }

  return (
    <Card title={t('pages.returns.sections.statusTimeline')} bordered>
      <Timeline items={items} />
    </Card>
  )
}
